import Vue from 'vue';
import LogRocket from 'logrocket';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import App from './App';
import router from './router';
import store from './store';
import './config/vuePlugins';
import '@/helpers/fontAwesomeIcons';
import './registerServiceWorker';
import './plugins/index';
import './assets/styles/tailwind.pcss';

// VueJS config
Vue.config.productionTip = false;

// Global Vue components
Vue.component('FontAwesomeIcon', FontAwesomeIcon);

// Setup error tracking with SentryJS and LogRocket (for Firebase dev and prod production environments)
if (process.env.NODE_ENV === 'production') {
  LogRocket.init(`3iqapi/eventor-${process.env.VUE_APP_MODE}`);
  LogRocket.info(`Eventor v${process.env.VUE_APP_VERSION}`);

  if (process.env.VUE_APP_MODE === 'development') {
    console.info(`Eventor v${process.env.VUE_APP_VERSION}`);
  }

  Sentry.init({
    dsn: 'https://5857a1a1b4b041a2a80370d9ca49fad6@sentry.io/1232184',
    environment: process.env.VUE_APP_MODE,
    release: `eventor-vuejs@${process.env.VUE_APP_VERSION}`,
    // Browser/network noise with no user impact (Sentry EVENTOR-VUEJS-FP/PG/KE/4R)
    ignoreErrors: [
      'ResizeObserver loop completed with undelivered notifications',
      'ResizeObserver loop limit exceeded',
      'Failed to fetch',
      'Network Error',
      'NetworkError when attempting to fetch resource',
      'Load failed',
      'Non-Error promise rejection captured',
      'Firebase Installation is not registered',
      /^false$/,
    ],
    integrations: [
      new Integrations.Vue({
        Vue,
        attachProps: true,
      }),
    ],
  });

  Sentry.configureScope((scope) => {
    LogRocket.getSessionURL((sessionURL) => {
      scope.setExtra('LogRocket session URL', sessionURL);
    });
  });
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
